import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SettingsState {
  landingPage: 'dashboard' | 'stores';
  theme: 'light' | 'dark';
}

const initialState: SettingsState = {
  landingPage: 'dashboard',
  theme: 'light'
};

const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    setLandingPage: (state, action: PayloadAction<'dashboard' | 'stores'>) => {
      state.landingPage = action.payload;
    },
    setTheme: (state, action: PayloadAction<'light' | 'dark'>) => {
      state.theme = action.payload;
    }
  }
});

export const { setLandingPage, setTheme } = settingsSlice.actions;
export default settingsSlice.reducer;